import classNames from 'classnames';
import CircularProgress from '@mui/material/CircularProgress';

import * as Styles from './Loading.styles';

const Loading = ({
  className = '',
  isLoading,
  textClassName = 'text-sm',
  small = false,
  extend = false,
  isHorizontal = false,
}) => {
  if (!isLoading) {
    return null;
  }
  return (
    <Styles.LoadingWrapper
      className={classNames(className, extend ? 'extend' : '')}
    >
      <div
        className={classNames(
          'flex h-full w-full items-center justify-center',
          isHorizontal ? 'flex-row' : 'flex-col'
        )}
      >
        <Styles.ldsEllipsis
          className={classNames('text-center', small ? 'small' : '')}
        >
          <CircularProgress />
        </Styles.ldsEllipsis>
        <div
          className={classNames(
            textClassName,
            'text-center loading-text whitespace-nowrap text-gray-700 dark:text-gray-200',
            small ? 'text-xs' : 'text-sm',
            isHorizontal ? 'ml-2' : ''
          )}
        >
          Đang tải dữ liệu...
        </div>
      </div>
    </Styles.LoadingWrapper>
  );
};

export default Loading;
